/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

export const leadSignalResponseDtoSchema = z.object({
    "id": z.string(),
"tenantId": z.string(),
"leadId": z.nullable(z.string()),
"interactionId": z.string(),
"type": z.enum(["INTEREST_EXPRESSED", "PROPERTY_NEEDS_DESCRIBED", "TIMELINE_MENTIONED", "MARKET_ANALYSIS_INQUIRED", "PROPERTY_VALUATION_REQUESTED", "AGENT_FEES_INQUIRED", "CLOSING_COSTS_INQUIRED", "FINANCING_DISCUSSED", "APPOINTMENT_INTENT_DETECTED", "PROPERTY_REFERENCED", "OFFER_DISCUSSED", "NEGOTIATION_STARTED", "TRANSACTION_STEP_OBSERVED", "LEASE_TERMS_DISCUSSED", "DELAY_INDICATED", "NO_INTEREST_EXPRESSED"]),
"occurredAt": z.iso.datetime(),
"confidence": z.number().describe("Confidence score between 0 and 1.0"),
"status": z.enum(["unprocessed", "processed", "active", "pending", "superseded", "rejected", "duplicated"]),
"metadata": z.optional(z.union([z.object({
    "intent": z.enum(["BUY", "SELL", "RENT", "RENT_OUT"]).nullish(),
"delayReason": z.string().nullish(),
"delayDuration": z.number().nullish(),
"delayUnit": z.enum(["days", "weeks", "months"]).nullish(),
"nextFollowUpDate": z.string().nullish(),
"nextFollowUpDateText": z.string().nullish()
    }), z.object({
    "intent": z.enum(["BUY", "SELL", "RENT", "RENT_OUT"]).nullish(),
"appointmentType": z.enum(["property_viewing", "consultation", "call", "other"]).nullish(),
"suggestedDate": z.string().nullish(),
"suggestedDateText": z.string().nullish(),
"suggestedTime": z.string().nullish(),
"locationOrAddress": z.string().nullish()
    }), z.object({
    "intent": z.enum(["BUY", "SELL", "RENT", "RENT_OUT"]).nullish()
    }), z.object({
    "intent": z.enum(["BUY", "SELL", "RENT", "RENT_OUT"]).nullish(),
"reason": z.string().nullish(),
"rejectionType": z.enum(["budget", "timing", "location", "already-purchased", "changed-plans", "other", "market-conditions", "fees", "already-rented", "already-rented-out"]).nullish(),
"willingToRevisit": z.boolean().nullish(),
"revisitTimeframe": z.string().nullish()
    }), z.object({
    "intent": z.enum(["BUY", "SELL", "RENT", "RENT_OUT"]).nullish(),
"prospectProperty": z.object({
    "addressLine1": z.string().nullish(),
"city": z.string().nullish(),
"state": z.string().nullish(),
"addressLine2": z.string().nullish(),
"zipCode": z.string().nullish(),
"lotSizeSqFt": z.number().nullish(),
"bathCount": z.number().nullish(),
"bedCount": z.number().nullish(),
"buildingName": z.string().nullish(),
"description": z.string().nullish(),
"garageSpaces": z.number().nullish(),
"hoaFeeCents": z.number().nullish(),
"currentPrice": z.number().nullish(),
"estimatedPrice": z.number().nullish(),
"livingAreaSqFt": z.number().nullish(),
"neighborhood": z.string().nullish(),
"style": z.string().nullish(),
"type": z.string().nullish(),
"lat": z.number().nullish(),
"lng": z.number().nullish(),
"yearBuilt": z.number().nullish(),
"floor": z.number().nullish(),
"hasDoormanAttendance": z.boolean().nullish(),
"isLease": z.boolean().nullish(),
"roomsTotal": z.number().nullish(),
"coverImageUrl": z.string().nullish(),
"mlsId": z.string().nullish(),
"mlsSource": z.string().nullish(),
"listingStatus": z.string().nullish()
    }).nullish(),
"propertyType": z.string().nullish(),
"comparableProperties": z.array(z.string()).nullish(),
"estimatedBudget": z.number().nullish(),
"estimatedExpectedValue": z.number().nullish(),
"valuationContext": z.enum(["buying", "investment", "other", "selling", "refinancing"]).nullish()
    }), z.object({
    "intent": z.enum(["BUY", "SELL", "RENT", "RENT_OUT"]).nullish(),
"feeType": z.enum(["commission", "flat-fee", "hourly", "full-service-cost", "other"]).nullish(),
"serviceScope": z.string().nullish(),
"estimatedPropertyValue": z.number().nullish()
    }), z.object({
    "intent": z.enum(["BUY", "SELL"]).nullish(),
"propertyType": z.string().nullish(),
"estimatedPropertyPrice": z.number().nullish(),
"estimatedLoanAmount": z.number().nullish(),
"downPaymentPercent": z.number().nullish(),
"loanType": z.enum(["conventional", "fha", "va", "usda", "jumbo", "other"]).nullish(),
"estimatedMortgageBalance": z.number().nullish(),
"expectedNetProceeds": z.number().nullish()
    }), z.object({
    "intent": z.enum(["BUY", "SELL", "RENT", "RENT_OUT"]).nullish(),
"location": z.string().nullish(),
"locationType": z.string().nullish(),
"marketContext": z.string().nullish(),
"interestType": z.enum(["trends", "comparables", "market-stats", "investment-potential", "other"]).nullish(),
"timeframe": z.string().nullish()
    }), z.object({
    "intent": z.enum(["BUY", "SELL", "RENT", "RENT_OUT"]).nullish(),
"deadlineDate": z.string().nullish(),
"deadlineDateText": z.string().nullish(),
"reason": z.enum(["relocation", "job-change", "life-event", "investment", "other"]).nullish()
    }), z.object({
    "intent": z.enum(["BUY", "RENT"]).nullish(),
"bedrooms": z.object({
    "min": z.number().nullish(),
"max": z.number().nullish()
    }).nullish(),
"bathrooms": z.object({
    "min": z.number().nullish(),
"max": z.number().nullish()
    }).nullish(),
"squareFootage": z.object({
    "min": z.number().nullish(),
"max": z.number().nullish()
    }).nullish(),
"propertyType": z.string().nullish(),
"location": z.string().nullish(),
"preferences": z.array(z.string()).nullish(),
"budget": z.object({
    "min": z.number().nullish(),
"max": z.number().nullish()
    }).nullish(),
"monthlyPaymentTarget": z.object({
    "min": z.number().nullish(),
"max": z.number().nullish()
    }).nullish()
    }), z.object({
    "intent": z.enum(["BUY", "SELL", "RENT", "RENT_OUT"]).nullish(),
"reason": z.optional(z.enum(["price_check", "fit_validation", "offer_strategy", "compare_options", "tour_request", "availability_check", "other", "pricing_benchmark", "competition_analysis", "positioning_strategy", "time_to_sell_estimate", "marketing_benchmark", "negotiation_anchor", "affordability_check", "eligibility_check", "location_fit", "application_intent", "rent_benchmark", "vacancy_estimate", "listing_optimization", "amenity_strategy", "tenant_targeting", "lease_terms_positioning"])),
"reference": z.optional(z.union([z.object({
    "type": z.enum(["listing_id"]),
"listingId": z.string()
    }), z.object({
    "type": z.enum(["url"]),
"url": z.string()
    }), z.object({
    "type": z.enum(["other"]),
"description": z.string()
    })])),
"aspectsEval": z.object({
    "price": z.enum(["too_high", "good", "low"]).nullish(),
"location": z.enum(["liked", "disliked"]).nullish(),
"size": z.enum(["too_small", "good", "too_large"]).nullish(),
"condition": z.enum(["needs_work", "good", "excellent"]).nullish(),
"layout": z.enum(["liked", "disliked"]).nullish(),
"features": z.array(z.object({
    "name": z.string(),
"evaluation": z.enum(["liked", "disliked", "missing", "neutral"]).nullish()
    })).nullish()
    }).nullish(),
"overallExpressedSentiment": z.enum(["positive", "negative", "mixed", "neutral"]).nullish()
    }), z.object({
    "intent": z.enum(["BUY"]).nullish(),
"preApprovalStatus": z.enum(["approved", "in-progress", "not-started"]).nullish(),
"loanType": z.enum(["conventional", "fha", "va", "usda", "jumbo", "other"]).nullish(),
"downPaymentPercent": z.number().nullish(),
"estimatedLoanAmount": z.number().nullish(),
"lenderMentioned": z.string().nullish()
    }), z.object({
    "intent": z.enum(["BUY", "SELL"]).nullish(),
"offerStatus": z.enum(["considering", "preparing", "submitted", "negotiating", "accepted", "other"]).nullish(),
"prospectProperty": z.object({
    "addressLine1": z.string().nullish(),
"city": z.string().nullish(),
"state": z.string().nullish(),
"addressLine2": z.string().nullish(),
"zipCode": z.string().nullish(),
"lotSizeSqFt": z.number().nullish(),
"bathCount": z.number().nullish(),
"bedCount": z.number().nullish(),
"buildingName": z.string().nullish(),
"description": z.string().nullish(),
"garageSpaces": z.number().nullish(),
"hoaFeeCents": z.number().nullish(),
"currentPrice": z.number().nullish(),
"estimatedPrice": z.number().nullish(),
"livingAreaSqFt": z.number().nullish(),
"neighborhood": z.string().nullish(),
"style": z.string().nullish(),
"type": z.string().nullish(),
"lat": z.number().nullish(),
"lng": z.number().nullish(),
"yearBuilt": z.number().nullish(),
"floor": z.number().nullish(),
"hasDoormanAttendance": z.boolean().nullish(),
"isLease": z.boolean().nullish(),
"roomsTotal": z.number().nullish(),
"coverImageUrl": z.string().nullish(),
"mlsId": z.string().nullish(),
"mlsSource": z.string().nullish(),
"listingStatus": z.string().nullish()
    }).nullish(),
"offeredPrice": z.number().nullish(),
"askingPrice": z.number().nullish(),
"closingTimeline": z.string().nullish(),
"inspectionContingency": z.boolean().nullish(),
"financingContingency": z.boolean().nullish(),
"appraisalContingency": z.boolean().nullish()
    }), z.object({
    "intent": z.enum(["BUY", "SELL", "RENT", "RENT_OUT"]).nullish(),
"negotiationSubject": z.string().nullish(),
"startedAt": z.string().nullish(),
"notes": z.string().nullish()
    }), z.object({
    "intent": z.enum(["BUY", "SELL", "RENT", "RENT_OUT"]).nullish(),
"step": z.enum(["property_selected", "tour_completed", "financial_precheck_done", "offer_submitted", "offer_countered", "offer_accepted", "inspection_completed", "issues_negotiated", "appraisal_completed", "loan_application_submitted", "loan_approved", "rental_application_submitted", "tenant_screening_completed", "lease_drafted", "contract_signed", "documents_verified", "closing_scheduled", "funds_transferred", "ownership_transferred", "keys_delivered", "move_in_completed", "transaction_closed"]).nullish(),
"status": z.enum(["planned", "in_progress", "completed"]).nullish(),
"stepText": z.string().nullish(),
"observedAt": z.string().nullish(),
"notes": z.string().nullish()
    }), z.object({
    "intent": z.enum(["RENT", "RENT_OUT"]).nullish(),
"monthlyRent": z.number().nullish(),
"leaseDurationMonths": z.number().nullish(),
"moveInDate": z.string().nullish(),
"termsNotes": z.string().nullish()
    })]).describe("Signal-type-specific metadata. Shape varies by lead signal type and intent.")),
"source": z.enum(["email:signature", "email:body", "email:headers", "email:subject", "email:quoted_text", "email:forward-header", "memo:body", "enrichment:social_profile", "user:input", "user:reviewed"]),
"signalQuality": z.enum(["direct", "inferred", "user_provided"]),
"quotedText": z.string(),
"createdAt": z.iso.datetime(),
"updatedAt": z.iso.datetime()
    })